export const environment = {
  production: false,
  hmr: false,
  baseUrl: 'https://wallet-admin.insureco.io',
  google: {
    reCaptcha: {
      siteKey: '6LcoJP0UAAAAAG98d_TVB1pVYCsxPK_U2Va6DpYO',
    },
    oAuth: {
      clientId: '447668739643-40vodfs0frl3c9f9p68nk1umumg7iih6.apps.googleusercontent.com',
    },
  },
  defaultPostLoginPath: '/wallets',
};
